import React from "react";
import "./Navbar.css";
import Modal from "./Modal";

function Navbar({ saveAsPDF, changeFormDisplay }) {
  function handleSave() {
    saveAsPDF();
  }

  function handleToggle(e) {
    changeFormDisplay(e.target.checked);
  }

  return (
    <>
      <div className="bg-emerald-100 flex py-3 px-16 justify-between text-slate-950">
        <div className="text-2xl font-extrabold">RESUME MAKER</div>
        <div className="flex align-center gap-6 text-sm items-center font-semibold">
          {/* <button className="help-btn border-b-2 border-emerald-100  hover:border-slate-900 transition ">
            {" "}
            Reset
          </button> */}
          <Modal />
          <button
            className="px-2 py-1 rounded-md border border-slate-900 hover:bg-emerald-200 transition duration-300"
            onClick={handleSave}
          >
            Download as PDF
          </button>
        </div>
      </div>
    </>
  );
}

export default Navbar;
